import { useEffect } from 'react';
import Hostname from './Hostname';
import applyDocumentBranding from '../helpers/applyDocumentBranding';

const useDocumentBranding = () => {
  const host = Hostname();

  useEffect(() => {
    // Only whitelabel hosts (a hostname match in ImpactManagers) get custom
    // branding. On the regular Deccos domain, keep the default title/favicon.
    if (!host || !host.Hostname) return;
    applyDocumentBranding({
      compagnyName: host.Name,
      logo: host.Logo,
      favicon: host.Favicon,
    });
  }, [host]);
};

export default useDocumentBranding;
